import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TuiTextfield } from '@taiga-ui/core';
import { TuiInputModule, TuiTextfieldControllerModule } from '@taiga-ui/legacy';

@Component({
    selector: 'ffx-search-input',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TuiTextfield,
        TuiInputModule,
        TuiTextfieldControllerModule
    ],
    templateUrl: './search-input.component.html',
    styleUrl: './search-input.component.scss'
})
export class SearchInputComponent {
    @Output() search = new EventEmitter<string>();

    protected searchFilterForm = new FormGroup({
        searchControl: new FormControl('')
    });

    onSearchChange(): void {
        this.search.emit(this.searchFilterForm.controls.searchControl.value || '');
    }

    clearSearch(): void {
        this.searchFilterForm.controls.searchControl.setValue('');
        this.onSearchChange();
    }
}
